import { Clock, PlayCircle, CheckCircle2, AlertCircle, DollarSign } from "lucide-react";

const ReferralTimeSaver: React.FC = () => {
  return (
    <section className="bg-[#050505] text-white py-24 px-4 border-t border-white/5">
      <div className="max-w-6xl mx-auto">
        
        {/* Cabecera de la sección */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-black mb-6 tracking-tighter">
            Stop paying <span className="text-cyan-400">$100/month</span> for platforms.
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Own your affiliate infrastructure. No monthly fees, no limits, just your code working for you.
          </p>
        </div>

        {/* Comparativa de Valor */}
        <div className="grid md:grid-cols-2 gap-8 mb-20">
          {/* El Camino Caro */}
          <div className="bg-white/[0.02] border border-gray-400 p-8 rounded-3xl">
            <h3 className="flex items-center gap-2 text-xl font-bold mb-6 text-gray-400">
              <DollarSign size={20} /> Third-Party Platforms
            </h3>
            <ul className="space-y-4 sm:text-lg text-sm text-gray-400">
              <li className="flex gap-2 text-red-400/80">❌ $49 - $149 Monthly Subscription</li>
              <li className="flex gap-2">❌ Transaction fees on every referral</li>
              <li className="flex gap-2">❌ Limited customization of the dashboard</li>
              <li className="flex gap-2">❌ Your data lives on their servers</li>
              <li className="flex gap-2">❌ Complex integration with your app</li>
              <li className="border-t border-white/10 pt-4 font-bold text-lg text-red-400/80">Total: $1,200+/Year forever</li>
            </ul>
          </div>

          {/* El Camino Cestio */}
          <div className="bg-cyan-400/5 border-2 border-cyan-400/30 p-8 rounded-3xl relative overflow-hidden shadow-[0_0_30px_rgba(34,211,238,0.1)]">
            <div className="absolute top-0 right-0 bg-cyan-400 text-black font-black text-[10px] px-3 py-1 rounded-bl-lg uppercase tracking-widest">
              Smart Choice
            </div>
            <h3 className="flex items-center gap-2 text-xl font-bold mb-6 text-cyan-400">
              <CheckCircle2 size={20} /> This Referral System
            </h3>
            <ul className="space-y-4 sm:text-lg text-sm text-gray-200">
              <li className="flex gap-2 font-medium">✅ Unique Code Generation & Tracking</li>
              <li className="flex gap-2 font-medium">✅ Stripe Connect for Payouts</li>
              <li className="flex gap-2 font-medium">✅ Automated Cron Jobs (Commissions)</li>
              <li className="flex gap-2 font-medium">✅ Admin & Affiliate Dashboards</li>
              <li className="flex gap-2 font-medium">✅ Full Source Code & Database Schema</li>
              <li className="border-t border-cyan-400/20 pt-4 font-black text-2xl text-white">Total: $9.99 (One-time)</li>
            </ul>
          </div>
        </div>

        {/* Sección del Video de YouTube */}
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col items-center mb-10">
            <div className="flex items-center gap-2 mb-3">
                <div className="bg-red-500/20 p-2 rounded-full">
                    <PlayCircle className="text-red-500" size={24} />
                </div>
                <span className="text-sm font-black tracking-[0.2em] uppercase text-gray-400">Step-by-Step Implementation</span>
            </div>
            {/* <h3 className="text-3xl md:text-4xl font-black text-center mb-4">
              I'll show you how to build it.
            </h3> */}
            <p className="text-gray-400 text-center max-w-xl">
                From Stripe Connect integration to automated payouts. Watch the full build and deploy with confidence.
            </p>
          </div>

          {/* Video Embed Container */}
          <div className="relative aspect-video rounded-3xl overflow-hidden border border-white/10 shadow-2xl group transition-transform hover:scale-[1.01] duration-500">
            <iframe
              className="absolute inset-0 w-full h-full"
              src="https://www.youtube.com/embed/EtJDZbKdIxM" // Pon aquí el ID de tu video de Referrals
              title="Referral System Tutorial"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
              {['Next.js 14+', 'Stripe Connect', 'Prisma ORM', 'Cron Jobs'].map((tech) => (
                  <div key={tech} className="bg-white/5 border border-white/10 py-3 rounded-xl text-center text-[10px] font-bold uppercase tracking-widest text-gray-400">
                      {tech}
                  </div>
              ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default ReferralTimeSaver;